import React from "react";
import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";
import { ChartData } from "chart.js";
import { useTranslation } from "react-i18next";

import { RootState } from "../../../../../store/store";
import ChartLegend from "../../ChartLegend/ChartLegend";
import { verticalChartOptions } from "../../../../../utils/charts/chartOptions";
import theme from "../../../../../components/styles/theme/theme";
import { StatisticsData } from "../../../../../features/statistics/types";

interface ImpactOverTimeByValueChartProps {
  previousYear: string | null;
  previousYearStatisticsData: StatisticsData | null;
}

const ImpactOverTimeByValueChart: React.FC<ImpactOverTimeByValueChartProps> = ({
  previousYear,
  previousYearStatisticsData,
}) => {
  const { t } = useTranslation();
  const {
    statistics: { statisticsForSelectedCountry },
    map: { year },
  } = useSelector((state: RootState) => state);

  const statisticsDataArray = !previousYearStatisticsData
    ? [
        [
          statisticsForSelectedCountry?.overtime_value_added
            ? statisticsForSelectedCountry?.overtime_value_added?.the_System
            : null,
        ],
        [
          statisticsForSelectedCountry?.overtime_value_added
            ? statisticsForSelectedCountry?.overtime_value_added?.upstream
            : null,
        ],
        [
          statisticsForSelectedCountry?.overtime_value_added
            ? statisticsForSelectedCountry?.overtime_value_added?.downstream
            : null,
        ],
      ].map((row) => row.map((value) => (value === 0 ? null : value)))
    : [
        [
          previousYearStatisticsData?.overtime_value_added
            ? previousYearStatisticsData?.overtime_value_added?.the_System
            : null,
          statisticsForSelectedCountry?.overtime_value_added
            ? statisticsForSelectedCountry?.overtime_value_added?.the_System
            : null,
        ],
        [
          previousYearStatisticsData?.overtime_value_added
            ? previousYearStatisticsData?.overtime_value_added?.upstream
            : null,
          statisticsForSelectedCountry?.overtime_value_added
            ? statisticsForSelectedCountry?.overtime_value_added?.upstream
            : null,
        ],
        [
          previousYearStatisticsData?.overtime_value_added
            ? previousYearStatisticsData?.overtime_value_added?.downstream
            : null,
          statisticsForSelectedCountry?.overtime_value_added
            ? statisticsForSelectedCountry?.overtime_value_added?.downstream
            : null,
        ],
      ].map((row) => row.map((value) => (value === 0 ? null : value)));
// @ts-ignore
  const data: ChartData<"bar"> = {
    labels: previousYear ? [previousYear, year] : [year],
    datasets: [
      {
        label: t("charts.system_label") || "",
        data: statisticsDataArray[0],
        backgroundColor: theme.palette.secondary["600"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.upstream_label") || "",
        data: statisticsDataArray[1],
        backgroundColor: theme.palette.secondary["200"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
      {
        label: t("charts.downstream_label") || "",
        data: statisticsDataArray[2],
        backgroundColor: theme.palette.primary["600"],
        minBarLength: 20,
        maxBarThickness: 80,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
      },
    ],
  };

  return (
    <>
      <Bar
        options={verticalChartOptions("impact_over_time", true)}
        data={data}
      />
      <ChartLegend data={data} />
    </>
  );
};
export default ImpactOverTimeByValueChart;
